export default {
	custom : {
		email : {
			required : 'El campo email es obligatorio',
			email : 'Debes indicar una dirección de correo electrónico válida'
		},
		amount : {
			required : 'Por favor selecciona una cantidad',
		},
		password : {
			required : 'Debes introducir una contraseña',
			min : 'La longitud mínima son 8 caracteres'
		},
		password_confirmation : {
			required : 'Debes introducir una contraseña',
			confirmed : 'Las contraseñas coinciden'
		},
		telefono : {
			required : 'El campo teléfono es obligatorio',
			length : 'El campo teléfono está mal formado'
		},
		name : {
			required : 'El campo nombre es obligatorio'
		},
		dni : {
			required : 'El campo dni es obligatorio'
		},
		phone : {
			required : 'El campo phone es obligatorio'
		},
		mensaje : {
			required : 'El campo mensaje es obligatorio'
		},
		apellidos : {
			required : 'El campo apellidos es obligatorio'
		},
		politica : {
			required : 'Debes aceptar la política de privacidad'
		},
		direccion : {
			required : 'El campo direccion es obligatorio'
		},
		pais : {
			required : 'El campo pais es obligatorio'
		},
		carta_presentacion : {
			required : 'El campo carta de presentación es obligatorio'
		},
		doc_adjunto : {
			size : 'El tamaño maximo son 2MB',
			mimes : 'El formato debe ser PDF'
		},
		amount : {
			max_value : "La mayor cantidad posible es 100€"
		}
	}
}


// WEBPACK FOOTER //
// ./src/validator/es.js